module.exports = __webpack_public_path__ + "media/homepage/vip-voice_@2x-283d0f12.png";